import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Upload, X, Loader2 } from 'lucide-react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
interface FormData {
  nombre: string;
  empresa: string;
  telefono: string;
  email: string;
  ciudad: string;
  volumen: string;
  tienePOS: string;
  proveedor: string;
  mensaje: string;
}
// ⚠️ IMPORTANTE: Reemplaza 'TU_FORM_ID' con tu ID de Formspree.
// 1. Ve a https://formspree.io y crea una cuenta gratis
// 2. Crea un nuevo formulario con el email: guillermo@vitalmerchantsolutions.com
// 3. Copia el ID del formulario (ej: "xpzvqkdl") y pégalo abajo
const FORMSPREE_ENDPOINT = 'https://formspree.io/f/xpqkjlbv';
export function ContactPage() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState<FormData>({
    nombre: '',
    empresa: '',
    telefono: '',
    email: '',
    ciudad: '',
    volumen: '',
    tienePOS: '',
    proveedor: '',
    mensaje: ''
  });
  const [file, setFile] = useState<File | null>(null);
  const [isDragging, setIsDragging] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(true);
  };
  const handleDragLeave = () => {
    setIsDragging(false);
  };
  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      setFile(e.dataTransfer.files[0]);
    }
  };
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);
    try {
      const submitData = new window.FormData();
      submitData.append('Nombre', formData.nombre);
      submitData.append('Empresa', formData.empresa);
      submitData.append('Teléfono', formData.telefono);
      submitData.append('Email', formData.email);
      submitData.append('Ciudad / Estado', formData.ciudad);
      submitData.append('Volumen Mensual', formData.volumen);
      submitData.append('Tiene POS', formData.tienePOS);
      submitData.append('Proveedor Actual', formData.proveedor);
      submitData.append('Mensaje', formData.mensaje);
      submitData.append('_subject', `Nueva solicitud de evaluación - ${formData.empresa}`);
      if (file) {
        submitData.append('attachment', file);
      }
      const response = await fetch(FORMSPREE_ENDPOINT, {
        method: 'POST',
        body: submitData,
        headers: {
          Accept: 'application/json'
        }
      });
      if (response.ok) {
        navigate('/gracias');
      } else {
        const data = await response.json();
        if (data.errors) {
          setError(data.errors.map((err: {
            message: string;
          }) => err.message).join(', '));
        } else {
          setError('Hubo un error al enviar el formulario. Por favor intenta de nuevo.');
        }
      }
    } catch (err) {
      setError('Error de conexión. Por favor verifica tu internet e intenta de nuevo.');
    } finally {
      setIsSubmitting(false);
    }
  };
  return <div className="w-full min-h-screen bg-lightGray" data-id="element-137">
      <Navbar data-id="element-138" />

      <div className="pt-24 pb-16" data-id="element-139">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-140">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="bg-navy text-white p-8 md:p-12 rounded-t-lg" data-id="element-141">
            <div className="w-16 h-1 bg-gold mb-6" data-id="element-142"></div>
            <h1 className="text-3xl md:text-4xl font-serif font-bold mb-4" data-id="element-143">
              Solicita tu evaluación gratuita
            </h1>
            <p className="text-lg text-gray-300" data-id="element-144">
              Completa el formulario y un especialista revisará tu información.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="bg-white p-8 md:p-12 rounded-b-lg shadow-xl" data-id="element-145">
            <form onSubmit={handleSubmit} className="space-y-6" data-id="element-146">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-147">
                <div data-id="element-148">
                  <label htmlFor="nombre" className="block text-sm font-semibold text-navy mb-2" data-id="element-149">
                    Nombre *
                  </label>
                  <input type="text" id="nombre" name="nombre" required value={formData.nombre} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-gold focus:border-transparent outline-none transition-all" data-id="element-150" />
                </div>

                <div data-id="element-151">
                  <label htmlFor="empresa" className="block text-sm font-semibold text-navy mb-2" data-id="element-152">
                    Empresa *
                  </label>
                  <input type="text" id="empresa" name="empresa" required value={formData.empresa} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-gold focus:border-transparent outline-none transition-all" data-id="element-153" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-154">
                <div data-id="element-155">
                  <label htmlFor="telefono" className="block text-sm font-semibold text-navy mb-2" data-id="element-156">
                    Teléfono *
                  </label>
                  <input type="tel" id="telefono" name="telefono" required value={formData.telefono} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-gold focus:border-transparent outline-none transition-all" data-id="element-157" />
                </div>

                <div data-id="element-158">
                  <label htmlFor="email" className="block text-sm font-semibold text-navy mb-2" data-id="element-159">
                    Email *
                  </label>
                  <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-gold focus:border-transparent outline-none transition-all" data-id="element-160" />
                </div>
              </div>

              <div data-id="element-161">
                <label htmlFor="ciudad" className="block text-sm font-semibold text-navy mb-2" data-id="element-162">
                  Ciudad / Estado *
                </label>
                <input type="text" id="ciudad" name="ciudad" required value={formData.ciudad} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-gold focus:border-transparent outline-none transition-all" data-id="element-163" />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-164">
                <div data-id="element-165">
                  <label htmlFor="volumen" className="block text-sm font-semibold text-navy mb-2" data-id="element-166">
                    ¿Cuánto procesas al mes? *
                  </label>
                  <select id="volumen" name="volumen" required value={formData.volumen} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-gold focus:border-transparent outline-none transition-all bg-white" data-id="element-167">
                    <option value="" data-id="element-168">Selecciona una opción</option>
                    <option value="30k-50k" data-id="element-169">$30,000 - $50,000</option>
                    <option value="50k-100k" data-id="element-170">$50,000 - $100,000</option>
                    <option value="100k-250k" data-id="element-171">$100,000 - $250,000</option>
                    <option value="250k+" data-id="element-172">$250,000+</option>
                  </select>
                </div>

                <div data-id="element-173">
                  <label htmlFor="tienePOS" className="block text-sm font-semibold text-navy mb-2" data-id="element-174">
                    ¿Tienes POS actual? *
                  </label>
                  <select id="tienePOS" name="tienePOS" required value={formData.tienePOS} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-gold focus:border-transparent outline-none transition-all bg-white" data-id="element-175">
                    <option value="" data-id="element-176">Selecciona una opción</option>
                    <option value="si" data-id="element-177">Sí</option>
                    <option value="no" data-id="element-178">No</option>
                  </select>
                </div>
              </div>

              <div data-id="element-179">
                <label htmlFor="proveedor" className="block text-sm font-semibold text-navy mb-2" data-id="element-180">
                  ¿Quién es tu proveedor actual?
                </label>
                <input type="text" id="proveedor" name="proveedor" value={formData.proveedor} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-gold focus:border-transparent outline-none transition-all" placeholder="Ej: Square, Clover, etc." data-id="element-181" />
              </div>

              <div data-id="element-182">
                <label htmlFor="mensaje" className="block text-sm font-semibold text-navy mb-2" data-id="element-183">
                  Mensaje
                </label>
                <textarea id="mensaje" name="mensaje" rows={4} value={formData.mensaje} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-gold focus:border-transparent outline-none transition-all resize-none" placeholder="Cuéntanos sobre tu negocio o cualquier pregunta que tengas..." data-id="element-184"></textarea>
              </div>

              <div data-id="element-185">
                <label className="block text-sm font-semibold text-navy mb-2" data-id="element-186">
                  Estado de cuenta (Merchant Statement)
                </label>
                <div onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop} className={`border-2 border-dashed rounded-lg p-8 text-center transition-all ${isDragging ? 'border-gold bg-gold bg-opacity-5' : 'border-gray-300 hover:border-gold'}`} data-id="element-187">
                  {file ? <div className="flex items-center justify-center space-x-3" data-id="element-188">
                      <span className="text-navy font-medium" data-id="element-189">{file.name}</span>
                      <button type="button" onClick={() => setFile(null)} className="text-red-500 hover:text-red-700" data-id="element-190">
                        <X size={20} data-id="element-191" />
                      </button>
                    </div> : <>
                      <Upload className="mx-auto text-gray-400 mb-3" size={40} data-id="element-192" />
                      <p className="text-gray-600 mb-2" data-id="element-193">
                        Arrastra tu archivo aquí o haz clic para seleccionar
                      </p>
                      <input type="file" onChange={handleFileChange} className="hidden" id="file-upload" accept=".pdf,.jpg,.jpeg,.png" data-id="element-194" />
                      <label htmlFor="file-upload" className="inline-block bg-navy text-white px-6 py-2 rounded-md cursor-pointer hover:bg-opacity-90 transition-all" data-id="element-195">
                        Seleccionar archivo
                      </label>
                      <p className="text-xs text-gray-500 mt-2" data-id="element-196">
                        PDF, JPG, PNG (máx. 10MB)
                      </p>
                    </>}
                </div>
              </div>

              {error && <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-md text-sm" data-id="element-197">
                  {error}
                </div>}

              <button type="submit" disabled={isSubmitting} className="w-full bg-gold text-navy px-8 py-4 rounded-md font-bold text-lg hover:bg-opacity-90 transition-all shadow-lg disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2" data-id="element-198">
                {isSubmitting ? <>
                    <Loader2 className="animate-spin" size={20} data-id="element-199" />
                    Enviando...
                  </> : 'Enviar para evaluación'}
              </button>

              <p className="text-sm text-gray-600 text-center bg-lightGray p-4 rounded-md" data-id="element-200">
                🔒 Revisamos tu información con confidencialidad. Solo te
                contactamos si vemos una oportunidad real de mejora.
              </p>
            </form>
          </motion.div>
        </div>
      </div>

      <Footer data-id="element-201" />
    </div>;
}